function Footer() {
  return(
  <footer>
    <div className="contact">
      <h3>Contact</h3>
      <p style={{ marginTop: "5px" }}>+91 3478631928 <br />
        perfumy@gmail.com
      </p>

    </div>
    <p style={{fontSize: "small", padding: "20px", color: "grey"}}>
            W3Schools is optimized for learning and training. Examples might be simplified to improve reading and
            learning. Tutorials, references, and examples are constantly reviewed to avoid errors, but we cannot warrant
            full correctness of all content. While using W3Schools, you agree to have read and accepted our terms of
            use, cookie and privacy policy.

            Copyright 1999-2023 by Refsnes Data. All Rights Reserved.
            W3Schools is Powered by W3.CSS.
        </p>
  </footer>)
}

export default Footer